import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isActive = (path: string) => {
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };

  const linkClass = (path: string) =>
    `text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
      isActive(path)
        ? "text-primary-500"
        : "text-foreground-700 hover:text-primary-500"
    }`;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className="ri-play-fill text-background-50 text-lg"></i>
            </div>
            <span className="text-lg font-semibold text-foreground-950 whitespace-nowrap" style={{ fontFamily: "var(--font-heading)" }}>
              蘑菇视频
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link to="/" className={linkClass("/")}>
              首页
            </Link>
            <Link to="/category/hot" className={linkClass("/category")}>
              分类
            </Link>
            <Link to="/articles" className={linkClass("/articles")}>
              文章资讯
            </Link>
            <Link to="/about" className={linkClass("/about")}>
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="#download"
              className="px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              免费下载
            </a>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg hover:bg-background-100 transition-colors cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl text-foreground-700 ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-4 flex flex-col gap-3">
            <Link to="/" className="py-2 text-foreground-700 hover:text-primary-500 text-sm font-medium transition-colors">
              首页
            </Link>
            <Link to="/category/hot" className="py-2 text-foreground-700 hover:text-primary-500 text-sm font-medium transition-colors">
              分类浏览
            </Link>
            <Link to="/articles" className="py-2 text-foreground-700 hover:text-primary-500 text-sm font-medium transition-colors">
              文章资讯
            </Link>
            <Link to="/about" className="py-2 text-foreground-700 hover:text-primary-500 text-sm font-medium transition-colors">
              关于我们
            </Link>
            <a
              href="#download"
              className="mt-2 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium text-center hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              免费下载
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}